export default __webpack_public_path__ + "static/media/navigation_bg-tablet.6377a827.png";